
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`An array of additional free text descriptions of the person's attendance at the institution.`}</p>
    <p>{`This typically includes activities, honours, awards or specialities achieved during their study.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;